// Every number here is a protocol value, not a tuning knob: changing one
// silently rewrites the review schedule of every record already stored.
// The split from ./decay mirrors yominoki's layout so the trees stay diffable.
import { WordReadingFluencyEnum } from "./fluency";

// Unknown and Predicted are floors: Infinity keeps them out of the SQL CASE.
export const DECAY_DAYS: Record<WordReadingFluencyEnum, number> = {
  [WordReadingFluencyEnum.Strong]: 60,
  [WordReadingFluencyEnum.Learned]: 21,
  [WordReadingFluencyEnum.Developing]: 7,
  [WordReadingFluencyEnum.Initial]: 3,
  [WordReadingFluencyEnum.Unknown]: Infinity,
  [WordReadingFluencyEnum.Predicted]: Infinity,
};

// Decay does not walk down one rung: Strong and Learned both drop to the level
// whose quizzing behavior the reader now needs.
const DEMOTE_TO: Record<WordReadingFluencyEnum, WordReadingFluencyEnum> = {
  [WordReadingFluencyEnum.Strong]: WordReadingFluencyEnum.Developing,
  [WordReadingFluencyEnum.Learned]: WordReadingFluencyEnum.Developing,
  [WordReadingFluencyEnum.Developing]: WordReadingFluencyEnum.Initial,
  [WordReadingFluencyEnum.Initial]: WordReadingFluencyEnum.Unknown,
  [WordReadingFluencyEnum.Unknown]: WordReadingFluencyEnum.Unknown,
  [WordReadingFluencyEnum.Predicted]: WordReadingFluencyEnum.Predicted,
};

export { DEMOTE_TO };

// Both arguments are interpolated unescaped: pass plain column references,
// never reader input (each is repeated several times in the output).
// `updatedAt` must be timestamptz: a `timestamp` column shifts by the session
// offset, an epoch integer column fails. The expression reads now(), so no
// index can back it; use it in SELECT/ORDER BY over a pre-narrowed set, not WHERE.
export function sqlDecayedLevelExpr({
  level,
  updatedAt,
}: {
  level: string;
  updatedAt: string;
}): string {
  return `CASE
    WHEN ${level} = ${WordReadingFluencyEnum.Strong}
     AND EXTRACT(EPOCH FROM now() - ${updatedAt}) / 86400 > ${DECAY_DAYS[WordReadingFluencyEnum.Strong]}
    THEN ${DEMOTE_TO[WordReadingFluencyEnum.Strong]}
    WHEN ${level} = ${WordReadingFluencyEnum.Learned}
     AND EXTRACT(EPOCH FROM now() - ${updatedAt}) / 86400 > ${DECAY_DAYS[WordReadingFluencyEnum.Learned]}
    THEN ${DEMOTE_TO[WordReadingFluencyEnum.Learned]}
    WHEN ${level} = ${WordReadingFluencyEnum.Developing}
     AND EXTRACT(EPOCH FROM now() - ${updatedAt}) / 86400 > ${DECAY_DAYS[WordReadingFluencyEnum.Developing]}
    THEN ${DEMOTE_TO[WordReadingFluencyEnum.Developing]}
    WHEN ${level} = ${WordReadingFluencyEnum.Initial}
     AND EXTRACT(EPOCH FROM now() - ${updatedAt}) / 86400 > ${DECAY_DAYS[WordReadingFluencyEnum.Initial]}
    THEN ${DEMOTE_TO[WordReadingFluencyEnum.Initial]}
    ELSE ${level}
  END`;
}
